<template>

    <div class="tw-m-5">

        <div class="tw-mb-1 tw-text-gray-600 label">Verticale marge</div>

        <small class="tw-block tw-mb-3 tw-text-gray-500 label tw-text-muted">Dit is een extra (wit)ruimte boven en onder
            het blok. Met dit zijn blokken beter te laten aansluiten.</small>

        <select
            class="focus:tw-border-blue-300 focus:tw-outline-none focus:tw-shadow-outline-blue form-control form-input sm:tw-leading-5 sm:tw-text-sm tw-border tw-border-gray-300 tw-border-solid tw-duration-150 tw-ease-in-out tw-mt-1 tw-px-3 tw-py-2 tw-rounded-md tw-shadow-sm tw-transition tw-w-full"
            @input="$set(options, 'margin', $event.target.value)"
            v-model="options.margin">
            <option v-for="option in margins" :value="option.value">{{ option.text }}</option>
        </select>

    </div>

</template>

<script>

export default {

    props: {
        options: Object,
    },

    data() {
        return {
            margins: [
                {
                    'text': 'Geen',
                    'value': '',
                },
                {
                    'text': 'Klein',
                    'value': 'tw-py-2 md:tw-py-4',
                },
                {
                    'text': 'Middel',
                    'value': 'tw-py-4 md:tw-py-8',
                },
                {
                    'text': 'Groot',
                    'value': 'tw-py-8 md:tw-py-16',
                },
                {
                    'text': 'Extra groot',
                    'value': 'tw-py-16 md:tw-py-32',
                },
            ]
        }
    },

    created()
    {
        // Automatically give a margin
        if( !this.options.margin ) {
            this.options.margin = 'tw-py-2 md:tw-py-4';
        }
    }
}

</script>
